export const PeriodicityTabsConstants = {
	Daily:"DAILY",
	Weekly:"WEEKLY",
	Monthly:"MONTHLY",
	Quarterly:"QTRLY",
	Annual:"ANNUAL",
};